module.exports = __webpack_public_path__ + "img/policy_banner.a245fbdf.jpg";